module.exports = __webpack_public_path__ + "static/media/energy-lanscape.0feeef4c.jpg";